import React from 'react';
import ColisCall from './ColisCall';
import { api_route, user_logout, get_statuts_shippeds, set_statuts_shippeds } from '../../helpers/Global';

export default class ColiAction extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            coli: (props.coli || {}),
            call_type: 'call',
            call_action: false,
            liste_statuts: [],
        }
    }

    componentDidMount() { 
        this.props.setCurrentPage('action_coli');
        var liste_statuts_shippeds = get_statuts_shippeds();
        
         fetch(api_route('statuts-shippeds'), { method: 'GET' })
                .then(resp => resp.json())
                .then(resp => {
                    if (resp.response === 'error-connected') {
                        user_logout();
                        this.props.history.push(`/user-logout`);
                    } else if (resp['liste-statuts']) {
                        
                        this.setState({ liste_statuts: resp['liste-statuts'] }, function () {
                            set_statuts_shippeds(this.state.liste_statuts);
                            if(this.props.coli_action == "call"){
                                this.saveAction("call");
                            }
                        });
                        
                    }
                })
                .catch(err => {
                    this.props.loaderDisplay(false);
                    this.props.openErrorSystem(true);
                })
        
        
        if (liste_statuts_shippeds.length === 0) {
            fetch(api_route('statuts-shippeds'), { method: 'GET' })
                .then(resp => resp.json())
                .then(resp => {
                    if (resp.response === 'error-connected') {
                        user_logout();
                        this.props.history.push(`/user-logout`);
                    } else if (resp['liste-statuts']) {
                        
                        this.setState({ liste_statuts: resp['liste-statuts'] }, function () {
                            set_statuts_shippeds(this.state.liste_statuts);
                            if(this.props.coli_action == "call"){
                                this.saveAction("call");
                            }
                        });
                        
                    }
                })
                .catch(err => {
                    this.props.loaderDisplay(false);
                    this.props.openErrorSystem(true);
                })
        } else {
            this.setState({ liste_statuts: liste_statuts_shippeds },function(){
                if(this.props.coli_action == "call"){
                    this.saveAction("call");
                }   
            });
            
        }
        
        

    }

    componentDidUpdate() {
        // back button 
        if (this.state.current_page !== this.props.current_page) {
            var call_action = this.state.call_action;
            if (this.props.current_page === 'action_coli') {
                call_action = false;
            }
            this.setState({
                current_page: this.props.current_page,
                call_action: call_action
            })
        }
    }

    render() {
        const coli = this.state.coli || {};
        const coli_action = this.props.coli_action;

        return (
            <React.Fragment>
                <div className="row mb-4 bg-template-opacity">
                    <div className="container py-4">
                        <div className="row">
                            <div className="col">
                                <h5 className="font-weight-normal template-primary">COLIS N° {coli.barecode}</h5>
                                <p className="text-secondary mb-0">
                                    <i className="ml-0 material-icons md-18 ml-1">account_box</i>
                                    {coli.recipient_name}
                                </p>
                                <p className="text-secondary mb-0">
                                    <i className="ml-0 material-icons md-18 ml-1">location_on</i>
                                    {coli.recipient_address} {coli.recipient_city}
                                </p>
                                <p className="text-secondary mb-0">
                                    <i className="ml-0 material-icons md-18 ml-1">attach_money</i>
                                    {coli.price}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                {!this.state.call_action ? (
                    <div className="row">
                        <div className="container">
                            <div className="card shadow-sm border-0 mb-4">
                                <div className="card-body">
                                    <div className="row justify-content-center">
                                        <div className="col-12 col-md-10 col-xl-8 mx-auto">
                                            <div className="form-group ">
                                                <div className="custom-control custom-radio">
                                                    <input
                                                        type="radio"
                                                        className="custom-control-input"
                                                        value="call"
                                                        name="type-call"
                                                        id="call"
                                                        checked={this.state.call_type === 'call'}
                                                        onChange={this.changeTypeCall}
                                                    />
                                                    <label className="custom-control-label" htmlFor="call">
                                                        Faire un <span className="text-primary">appel</span> au client.
                                                    </label>
                                                </div>
                                            </div>
                                            {coli_action !== 'echec' ? (
                                                <div className="form-group">
                                                    <div className="custom-control custom-radio">
                                                        <input
                                                            type="radio"
                                                            className="custom-control-input"
                                                            value="message"
                                                            name="type-call"
                                                            id="message"
                                                            checked={this.state.call_type === 'message'}
                                                            onChange={this.changeTypeCall}
                                                        />
                                                        <label className="custom-control-label" htmlFor="message">
                                                            Envoyer un <span className="text-primary">message</span> au client.
                                                    </label>
                                                    </div>
                                                </div>

                                            ) : (
                                                    <div className="form-group">
                                                        <div className="custom-control custom-radio">
                                                            <input
                                                                type="radio"
                                                                className="custom-control-input"
                                                                value="echec"
                                                                name="type-call"
                                                                id="echec"
                                                                checked={this.state.call_type === 'echec'}
                                                                onChange={this.changeTypeCall}
                                                            />
                                                            <label className="custom-control-label" htmlFor="echec">
                                                                Sélectionnez une <span className="text-primary">raison d'échec</span> de livraison.
                                                    </label>
                                                        </div>
                                                    </div>
                                                )}
                                        </div>
                                    </div>
                                </div>
                                <div className="card-footer">
                                    <button className="btn btn-info float-right submit-calls" onClick={() => this.saveAction()}>Suivant</button>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                        <ColisCall
                            coli={this.state.coli}
                            loaderDisplay={this.props.loaderDisplay}
                            coli_action={this.props.coli_action}
                            initCallAction={this.initCallAction}
                            liste_statuts={this.state.liste_statuts}
                            call_type={this.state.call_type}
                            setCurrentPage={this.props.setCurrentPage}
                            openErrorSystem={this.props.openErrorSystem}

                        />
                    )}

            </React.Fragment>
        );
    }

    initCallAction = () => {
        this.setState({ call_action: false });
    }

    saveAction = (default_action = null) => {
        const coli = this.state.coli;
        const call_type = default_action ? "call" : this.state.call_type;
        coli.call_type = call_type;
        if (call_type !== 'message') {

            var timing = 0;
            var make_call = false;
            if (window.isNativeApp && call_type === 'call') {
                this.props.loaderDisplay(true);
                make_call = true;
                timing = 10000;
            }
            setTimeout(
                function () {
                    this.setState({
                        call_action: true,
                        coli: coli
                    },function(){
                        this.props.loaderDisplay(false);
                    });
                    
                }.bind(this), timing
            );
            if (make_call) {
               return window.ReactNativeWebView.postMessage("call-user=" + coli.recipient_phone);
            }

        }
    }

    changeTypeCall = (event) => {
        const target = event.target;
        this.setState({ call_type: target.value });
    }

}
